import { breakpoints, Button, Dialog, Heading, Inline, Stack } from '@etg/wings';
import { css } from '@eti/styles';
import type { FormEvent } from 'react';
import { useState } from 'react';
import { useTranslation } from '@eti/providers';
import { OrderStatusState } from '@eti/schema-types';
import { capitalize } from '../utils';
import RadioSelection from './common/RadioSelection';
import SelectBoxSelection from './common/SelectBoxSelection';
import { DebugButton } from './index';

const dialogStyles = css`
  min-height: 37rem;
`;
const legendStyles = css`
  padding-top: 16px;
`;

const orderStatusPageStateOptions = [
  { label: 'CONFIRMED', value: OrderStatusState.Confirmed },
  { label: 'PROCESSING', value: OrderStatusState.Processing },
  { label: 'PROCESSING PAYMENT', value: OrderStatusState.ProcessingPayment },
  { label: 'FAILED', value: OrderStatusState.Failed },
];

const orderStatusPageOrderedAtThresholdOptions = [
  { label: 'Just now', value: '0' },
  { label: '12+ hours ago', value: '12' },
  { label: '24+ hours ago', value: '24' },
  { label: '36+ hours ago', value: '36' },
  { label: '48+ hours ago', value: '48' },
  { label: '60+ hours ago', value: '60' },
];

const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
  const formData = new FormData(event.currentTarget);
  const formEntries = Array.from(formData.entries());

  for (const [key, value] of formEntries) {
    sessionStorage.setItem(`mocked${capitalize(key)}`, String(value));
  }
};

const DebugOrderStatusPage = () => {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <DebugButton
        data-testid="order-status-properties-button"
        onClick={() => {
          setIsDialogOpen(true);
        }}
      >
        Order Status properties
      </DebugButton>
      <Dialog
        closeButtonAriaLabel={t('ScreenReader.CloseButtonDialog.AriaLabel.Text')}
        footer={
          <Inline align="end" collapseBelow={breakpoints._560}>
            <Button
              data-testid="order-status-properties-save-button"
              form="orderStatusPropertiesConfigForm"
              type="submit"
              variant="primary"
            >
              Save
            </Button>
          </Inline>
        }
        isOpen={isDialogOpen}
        onDismiss={() => {
          setIsDialogOpen(false);
        }}
        title="Order Status properties"
      >
        <form
          action="/debug.orderstatusproperties.mock.config"
          className={dialogStyles}
          id="orderStatusPropertiesConfigForm"
          method="POST"
          onSubmit={handleSubmit}
        >
          <Stack>
            <RadioSelection
              defaultValue="no"
              id="isOrderStatusPageChatEnabled"
              label="Enable chat"
            />
            <SelectBoxSelection
              data-testid="orderStatusPageState-dropdown"
              defaultValue={orderStatusPageStateOptions[0].value}
              label="State for order status page"
              name="orderStatusPageState"
              options={orderStatusPageStateOptions}
              placeholder="Please select…"
            />
            <SelectBoxSelection
              data-testid="orderStatusPageOrderedAtThreshold-dropdown"
              defaultValue={orderStatusPageOrderedAtThresholdOptions[0].value}
              label="State for order status page"
              name="orderStatusPageOrderedAtThreshold"
              options={orderStatusPageOrderedAtThresholdOptions}
              placeholder="Please select…"
            />
          </Stack>
          <Stack>
            <Heading as="legend" className={legendStyles} level={3}>
              Widgets
            </Heading>
            <RadioSelection
              defaultValue="no"
              id="showUpsellBookingCom"
              label="Show booking.com banner on Order Status page?"
            />
            <RadioSelection
              defaultValue="no"
              id="showUpsellBookingCars"
              label="Show booking cars widget banner on Order Status page?"
            />
          </Stack>
        </form>
      </Dialog>
    </>
  );
};

export default DebugOrderStatusPage;
